<template>

  <section class="bg">

    <Header page="settings" title="⚒️ Account Settings"/>

    <div class="container">

      <div class="settings-nav">
        <div :class="{ active: active_page === 'general'}" @click="active_page='general'">
          <p>⚒️ General</p>
        </div>
        <div :class="{ active: active_page === 'team'}"    @click="active_page='team'" >
          <p>👯 Team</p>
        </div>
        <div :class="{ active: active_page === 'billing'}" @click="active_page='billing'" v-if="is_admin">
          <p>💳 Billing</p>
        </div>
        <div :class="{ active: active_page === 'api'}" @click="active_page='api'" v-if="is_admin" class="api">
          <p>🤖 API</p>
          <p class="beta">BETA</p>
        </div>
      </div>

      <General v-if="active_page === 'general'" />
      <Team v-if="active_page === 'team'" />
      <Billing  v-if="active_page === 'billing'" />
      <API  v-if="active_page === 'api'" />

    </div>

  </section>
</template>


<script>

import Header from '@/components/Header.vue';

import General from '@/components/settings/General.vue';
import Team from '@/components/settings/Team.vue';
import Billing from '@/components/settings/Billing.vue';
import API from '@/components/settings/API.vue';

export default {

  name: 'Settings',

  components: {
    Header,
    General,
    Team,
    Billing,
    API
  },

  data: function () {
    return {
      active_page: 'general'
    }
  },

  computed: {
    is_admin() {
      return this.$store.state.user.role === 'admin';
    }
  },

  methods: {},

  mounted() {
    if (window.location.href.includes('billing')) {
      this.active_page = 'billing';
    };
  },

  created() {
    analytics.page('Settings');
  }

};
</script>

<style lang="scss" scoped>

section.bg{
  padding-bottom: 50px;
  background-image: linear-gradient(135deg, #eff0f3 1%,#fefeff 100%);
  min-height: 100%;
}

p{
  color: #0D303F;
}

.container{
  width: 900px;
  height: auto;
  margin: 0 auto;
  margin-top: 80px;
  background-color: white;
  border: 1px solid rgb(220,220,220);
  border-radius: 6px;
  font-family: 'Montserrat', sans-serif;
}

.settings-nav{
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgb(220,220,220);
  border-radius: 6px;
  background-color: rgb(250,250,250);
  & > div{
    width: 14%;
    margin-left: 2%;
    margin-right: 2%;
    height: 65px;
    cursor: pointer;
    p{
      font-size: 16px;
      font-weight: 600;
      line-height: 65px;
      text-align: center;
      margin-bottom: 0px;
      transition: all 0.15s ease;
      opacity: .75;
      &:hover{
        opacity: 1;
      }
    }
    &.active p{
      opacity: 1;
      font-weight: 700;
      border-bottom: 3px solid #36C4A5;
    }
    &.api{
      position: relative;
      .beta{
        position: absolute;
          bottom: 26px;
          right: 7px;
        font-size: 9px;
        font-weight: 700;
        line-height: 0px;
        margin: 0;
        opacity: .6;
        border-bottom: none;
      }
    }
  }
}


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

.container{
  width: 90%;
  margin-top: 60px;
}

.settings-nav{
  div{
    width: 28%;
  }
}
}

@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
  .container{
    width: 90%;
    margin-top: 60px;
  }
  .settings-nav{
    div{
      width: 28%;
    }
  }
}



</style>
